import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type Operator = {
  operatorId: string
  name: string | null
  email: string
  avatarUrl: string | null
  role: string
}

export const OPERATOR_LIST_KEY = 'operatorsList'

export const useGetList = () => {
  return useQuery({
    queryKey: [OPERATOR_LIST_KEY],
    queryFn: async () => {
      const response = await apiClient.get<Operator[]>('/int/v3/operators')
      return response.data
    },
  })
}
